import { Component, Vue } from "vue-property-decorator";
import { LocaleMessage } from "vue-i18n";

@Component({})
export default class NotificationEvent extends Vue {
  onDefault(
    title: LocaleMessage,
    description: LocaleMessage,
    duration: number | string = 5000
  ): void {
    this.$vs.notification({
      duration: duration,
      color: "primary",
      progress: "auto",
      //border: "primary",
      //icon: '<i class="fas fa-info" style="color: #2b3d8e"></i>',
      title: title,
      text: description,
      position: "top-right",
    });
  }
  onSuccess(
    title: LocaleMessage,
    description: LocaleMessage,
    duration: number | string = 5000
  ): void {
    this.$vs.notification({
      duration: duration,
      color: "success",
      progress: "auto",
      //border: "success",
      //icon: '<i class="fas fa-check" style="color: rgb(23, 201, 100)"></i>',
      title: title,
      text: description,
      position: "top-right",
    });
  }
  onError(
    title: LocaleMessage,
    description: LocaleMessage,
    duration: number | string = 5000
  ): void {
    this.$vs.notification({
      duration: duration,
      color: "danger",
      progress: "auto",
      //border: "error",
      //icon: '<i class="fas fa-times" style="color: rgb(242, 19, 93)"></i>',
      title: title,
      text: description,
      position: "top-right",
    });
  }
  onWarning(
    title: LocaleMessage,
    description: LocaleMessage,
    duration: number | string = 5000
  ): void {
    this.$vs.notification({
      duration: duration,
      color: "warning",
      progress: "auto",
      //border: "warning",
      //icon'<i class="fas fa-exclamation" style="color: rgb(255, 130, 0)"></i>',
      title: title,
      text: description,
      position: "top-right",
    });
  }
}
